export class FiscalYearUtils {
  
    static getFiscalYearFromDate(date: Date): number {
        const month = date.getMonth();
        const year = date.getFullYear();
        return month >= 9 ? year + 1 : year;
    }

    
    static getCurrentFiscalYear(): number {
        return this.getFiscalYearFromDate(new Date());
    }

    static isCurrentlyInQ4(): boolean {
        const currentMonth = new Date().getMonth();
        return currentMonth >= 9 && currentMonth <= 11;
    }
}

